export default __webpack_public_path__ + "static/media/plus-circle.21e8d9e4.svg";